import { ChangeDetectorRef, Component, ComponentFactoryResolver, ComponentRef, EventEmitter, Inject, Injector, Input, LOCALE_ID, OnInit, Optional, Output, TemplateRef, ViewChild } from '@angular/core';
import { HttpService } from '@ecp-caf/caf-common';
import { DatagridComponent } from '@farris/ui-datagrid';
import { FDropdownDirective } from '@farris/ui-dropdown';
import { MessagerService } from '@farris/ui-messager';
import { BsModalRef, BsModalService } from '@farris/ui-modal';
import { TypeConverter } from '@farris/ide-property-panel';
import { ExprEditMode, ExpressionService, InjectedType } from '@gsp-svc/expression';
import { ProcessDesignerUIState } from '../../app/process-designer.uistate';
import { OrganizationParticipantExpression } from '../../domain/entities/organization-participant-expression';
import { ProcessDeUtil } from '../../domain/process-de-util';
import { ComponentPerformer } from '../performer/views/component-performer/component-performer.entity';
import { PerformerEditComponent } from '../performer/views/performer-edit/performer-edit.component';
import { AssignConfig } from './assign-config';
import { ActivityExecutorParticipant, ComponentParticipant, MatrixParticipant, OrganizationParticipant, ParticipantInfo, PositionParticipant, ReportingLineParticipant, UserParticipant, VariableParticipant } from './participant.info';
import { ParticipantUIState } from './participant.uistate';
import { EditorTypes } from '@farris/ui-datagrid-editors';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../i18n/assets/lang.resource';

@Component({
  selector: 'lib-participant',
  templateUrl: './participant.component.html',
  styleUrls: ['./participant.component.scss'],
  providers: [
    ParticipantUIState,
     WfLocalePipe
  ]
})
export class ParticipantComponent implements OnInit {

  @Output() closeModal = new EventEmitter<any>();
  @Output() submitModal = new EventEmitter<any>();

  @ViewChild('iconSelectFooter') modalFooter: TemplateRef<any>;
  @ViewChild('dropdownEl') dropDownEl: FDropdownDirective;
  @ViewChild('dropdownE2') dropDownE2: FDropdownDirective;
  @ViewChild('editFooter') editFooter: TemplateRef<any>;
  @ViewChild('humanPerformerGrid') humanPerformerGrid: DatagridComponent;
  @ViewChild('potentialOwnerGrid') potentialOwnerGrid: DatagridComponent;

  @Input() editorParams: any = {};

  @Input() set value(participant: ParticipantInfo) {
    this.participant = JSON.parse(JSON.stringify(participant));
    if (!this.participant.assignStrategy.assignConfig) {
      this.participant.assignStrategy.assignConfig = new AssignConfig();
    }
    this.preAssignStrategy = participant.assignStrategy.assignStrategy;
    if (this.participant.humanPerformerList
      && this.participant.humanPerformerList.length > 0
    ) {
      if (Math.max(...this.participant.humanPerformerList.map(p => p.order)) === 0) {
        let index = 1;
        for (const humanPerformer of this.participant.humanPerformerList) {
          humanPerformer.order = index;
          index++;
        }
      }
      this.participant.humanPerformerList = this.participant.humanPerformerList.sort((a, b) => a.order - b.order);
    }
    if (this.participant.potentialOwnerList
      && this.participant.potentialOwnerList.length > 0) {
      if (Math.max(...this.participant.potentialOwnerList.map(p => p.order)) === 0) {
        let index = 1;
        for (const potentialOwner of this.participant.potentialOwnerList) {
          potentialOwner.order = index;
          index++;
        }
      }
      this.participant.potentialOwnerList = this.participant.potentialOwnerList.sort((a, b) => a.order - b.order);
    }
  }

  private preAssignStrategy;

  nodeType: 'userActivity' | 'notifyActivity'  = 'notifyActivity';

  editDialog: BsModalRef;
  compRef: ComponentRef<PerformerEditComponent>;
  isClose = true;

  participant: ParticipantInfo = new ParticipantInfo();
  editState = 'new'; // 编辑状态，用于区分是新增还是编辑  new | edit

  type = 'humanPerformer';

  assignStrategyList = [
    { value: 'ALL', name: this.localePipe.transform('component.participant.all') },
    { value: 'ASSIGN', name: this.localePipe.transform('component.participant.assign') },
    { value: 'CLAIM', name: this.localePipe.transform('component.participant.claim') }
  ];


  operatorCollection = [
    { text: this.localePipe.transform('component.participant.currentUser'), value: 'currentUser' },
    { text: this.localePipe.transform('component.participant.procInstCreator'), value: 'procInstCreator' }
  ];

  modalConfig = {
    title: this.localePipe.transform('component.participant.participantSet'),
    width: 900,
    height: 662,
    showButtons: true
  };

  columns = [
    {
      field: 'order', width: 25, title: this.localePipe.transform('component.participant.order'),
      editor: {
        type: EditorTypes.NUMBERBOX, options: {
        }
      },
    }, {
    field: 'type', width: 50, title: this.localePipe.transform('component.participant.type'),
    formatter: {
      type: 'enum',
      options: { valueField: 'value', textField: 'text', data: this.uistate.typeCollection }
    }
    }, {
    field: 'performerName', width: 50, title: this.localePipe.transform('component.participant.performerName'), showTips: true, formatter: (v, d, i) => {
      switch (d.type) {
        case 'wf.UserParticipantExpression':
          return d.performerName;
        case 'wf.VariableParticipantExpression':
          return (d as VariableParticipant).name;
        case 'wf.PositionParticipantExpression':
          return (d as PositionParticipant).performerName;
        case 'wf.ComponentParticipantExpression':
          return (d as ComponentParticipant).name;
        case 'wf.ReportingLineParticipantExpression':
          return (d as ReportingLineParticipant).reportingLineDefName + '-' + (d as ReportingLineParticipant).dimension;
        case 'wf.MatrixParticipantExpression':
          return (d as MatrixParticipant).matrixDefName + '-' + (d as MatrixParticipant).dataFieldAlias;
        case 'wf.ActivityExecutorParticipantExpression':
          return (d as ActivityExecutorParticipant).performerName;
        case 'wf.OrganizationParticipantExpression':
          return (d as OrganizationParticipant).organizationName;
        default:
          return '';
      }
    }
  },
  {
    field: 'description', width: 100, title: this.localePipe.transform('component.participant.description'), showTips: true,
    formatter: (v, d, i) => {
      switch (d.type) {
        case 'wf.UserParticipantExpression':
          return this.getUserPerformerDescription(d);
        case 'wf.VariableParticipantExpression':
          return this.getVariablePerformerDescription(d);
        case 'wf.PositionParticipantExpression':
          return this.getPositionPerformerDescription(d);
        case 'wf.ComponentParticipantExpression':
          return this.getComponentPerformerDescription(d);
        case 'wf.ReportingLineParticipantExpression':
          return this.getReportingLinePerformerDescription(d);
        case 'wf.MatrixParticipantExpression':
          return this.getMatrixPerformerDescription(d);
        case 'wf.ActivityExecutorParticipantExpression':
          return (d as ActivityExecutorParticipant).performerName;
        case 'wf.OrganizationParticipantExpression':
          return (d as OrganizationParticipant).organizationName + '，且' + ((d as OrganizationParticipant).includeChildren ? '包含下级' : '不包含下级');
        default:
          return '';
      }
    }
  },
  {
    field: 'condition', width: 60, title: this.localePipe.transform('component.participant.condition'), showTips: true,
    editor: {
      type: 'input-group',
      options: {
        groupText: '<i class="f-icon f-icon-lookup"></i>',
        editable: false,
        clickHandle: (e) => {
          e.formControl.setValue(e.instance.value ? e.instance.value : '');
          this.editConditon(e);
        },
      }
    }
    }];

  constructor(
    public designerUIState: ProcessDesignerUIState,
    private uistate: ParticipantUIState,
    private resolver: ComponentFactoryResolver,
    private injector: Injector,
    private modalService: BsModalService,
    private message: MessagerService,
    private expr: ExpressionService,
    private http: HttpService,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
    this.GetOrganizationType();
  }

  ngOnInit() {
    this.nodeType = this.editorParams.nodeType;
  }


  clickOK() {
    this.humanPerformerGrid.endCellEdit();
    if (this.potentialOwnerGrid) {
      this.potentialOwnerGrid.endCellEdit();
    }
    const object = {
      value: this.participant, parameters: null
    };
    this.submitModal.emit(object);
  }

  clickCancel() {
    this.closeModal.emit();
  }

  assignStrategyChange(data) {
    if (this.preAssignStrategy !== 'ASSIGN' && data === 'ASSIGN' && this.participant.humanPerformerList.length > 0) {
      if (!this.participant.assignStrategy.assignConfig) {
        this.participant.assignStrategy.assignConfig = new AssignConfig();
      }
      this.message.question(this.localePipe.transform('component.participant.dataMovement1'), () => {
        this.humanPerformerCopyToPotentialOwner();
      });
    } else if (this.preAssignStrategy === 'ASSIGN' && data !== 'ASSIGN' && this.participant.potentialOwnerList.length > 0) {
      this.message.question(this.localePipe.transform('component.participant.dataMovement2'), () => {
        this.potentialOwnerCopyToHumanPerformer();
      });
    }
    this.preAssignStrategy = data;
  }

  switchChange(data: boolean) {
    if (data) {
      this.clearPerformer('potentialOwner');
    }
  }

  addPerformer(performerType: string, type: string) {
    this.editState = 'new';
    this.type = type;
    const compFactory = this.resolver.resolveComponentFactory(PerformerEditComponent);
    this.compRef = compFactory.create(this.injector);
    this.compRef.instance.performerType = performerType;
    const boxsize = this.attributeBoxSize(performerType);
    const modalConfig = {
      title: this.localePipe.transform('component.participant.participantSelection'),
      width: boxsize.width,
      height: boxsize.height,
      buttons: this.editFooter,
      showButtons: true
    };
    this.editDialog = this.modalService.show(this.compRef, modalConfig);
    this.dropDownEl.close();
    if (this.dropDownE2) {
      this.dropDownE2.close();
    }
  }

  editOK() {
    this.isClose = true;
    if (this.compRef) {
      const re = this.compRef.instance.getPerformers();
      if (re.userPerformers && re.userPerformers.length > 0) {
        for (const p of re.userPerformers) {
          this.addUserPerformer(p);
        }
      }
      if (re.variable && re.variable !== null && re.variable.performerId) {
        this.addvariablePerformer(re.variable);
      }
      // 2023-7-28 组织岗支持多选
      if (re.positions && re.positions.length > 0) {
        this.addPositionPerformer(re.positions);
      }
      if (re.component && re.component.metadataId && re.component.methodCode) {
        this.addComponentPerformer(re.component);
      }
      if (re.reportingLine && re.reportingLine.reportingLineDefId && re.reportingLine.dimension) {
        this.addReportingLinePerformer(re.reportingLine);
      }
      if (re.matrix && re.matrix.matrixDefId) {
        this.addMatrixPerformer(re.matrix);
      }
      if (re.activityExecutorPerformers && re.activityExecutorPerformers.length > 0) {
        for (const a of re.activityExecutorPerformers) {
          this.addActivityExecutorPerformer(a);
        }
      }
      if (re.organizationParticipant) {
        this.addOrganizationParticipant(re.organizationParticipant);
      }
    }
    if (this.editDialog && this.isClose) {
      this.editDialog.close();
    }   
    // 编辑完成后刷新两个组件
    if(this.humanPerformerGrid) {
      this.humanPerformerGrid.refresh();
    }
    if(this.potentialOwnerGrid) {
      this.potentialOwnerGrid.refresh();
    }
  }

  private addUserPerformer(userPerformer: UserParticipant) {
    if (this.type === 'humanPerformer') {
      const i = this.participant.humanPerformerList.findIndex(a => (a.id === userPerformer.id || ((a as UserParticipant).performerId && (a as UserParticipant).performerId === userPerformer.performerId)));
      if (i > -1) {
        // this.participant.humanPerformerList[i] = userPerformer;
      } else {
        if (this.editState === 'edit') {
          this.removeHumanPerformer();
        }
        let index;
        if (this.participant.humanPerformerList.length > 0) {
          index = Math.max(...this.participant.humanPerformerList.map(h => h.order))+1;
        } else {
          index = 1;
        }
        userPerformer.order = index;
        this.participant.humanPerformerList.push(userPerformer);
      }
      this.humanPerformerGrid.loadData(this.participant.humanPerformerList);
    } else if (this.type === 'potentialOwner') {
      const i = this.participant.potentialOwnerList.findIndex(a => (a.id === userPerformer.id || ((a as UserParticipant).performerId && (a as UserParticipant).performerId === userPerformer.performerId)));
      if (i > -1) {
        // this.participant.potentialOwnerList[i] = userPerformer;
      } else {
        if (this.editState === 'edit') {
          this.removePotentialOwner();
        }
        let index;
        if (this.participant.potentialOwnerList.length > 0) {
          index = Math.max(...this.participant.potentialOwnerList.map(p => p.order))+1;
        } else {
          index = 1;
        }
        userPerformer.order = index;
        this.participant.potentialOwnerList.push(userPerformer);
      }
      this.potentialOwnerGrid.loadData(this.participant.potentialOwnerList);
    }
  }

  private addvariablePerformer(variable: VariableParticipant) {
    const v = variable;
    if (!v || !v.varValue) {
      this.message.info(this.localePipe.transform('component.participant.selectProcessVariables'));
      this.isClose = false;
    } else if (!v.varType) {
      this.message.info(this.localePipe.transform('component.participant.selectVariableValueType'));
      this.isClose = false;
    } else if (!v.relation) {
      this.message.info(this.localePipe.transform('component.participant.selectRelation'));
      this.isClose = false;
    } else {
      if (this.type === 'humanPerformer') {
        const i = this.participant.humanPerformerList.findIndex(a => (a.id === variable.id || ((a as VariableParticipant).performerId && (a as VariableParticipant).performerId === variable.performerId)));
        if (i > -1) {
          variable.order = i + 1;
          this.participant.humanPerformerList[i] = variable;
        } else {
          if (this.editState === 'edit') {
            this.removeHumanPerformer();
          }
          let index;
          if (this.participant.humanPerformerList.length > 0) {
            index = Math.max(...this.participant.humanPerformerList.map(h => h.order))+1;
          } else {
            index = 1;
          }
          variable.order = index;
          this.participant.humanPerformerList.push(variable);
        }
        this.humanPerformerGrid.loadData(this.participant.humanPerformerList);
      } else if (this.type === 'potentialOwner') {
        const i = this.participant.potentialOwnerList.findIndex(a => (a.id === variable.id || ((a as VariableParticipant).performerId && (a as VariableParticipant).performerId === variable.performerId)));
        if (i > -1) {
          variable.order = i + 1;
          this.participant.potentialOwnerList[i] = variable;
        } else {
          if (this.editState === 'edit') {
            this.removePotentialOwner();
          }
          let index;
          if (this.participant.potentialOwnerList.length > 0) {
            index = Math.max(...this.participant.potentialOwnerList.map(p => p.order))+1;
          } else {
            index = 1;
          }
          variable.order = index;
          this.participant.potentialOwnerList.push(variable);
        }
        this.potentialOwnerGrid.loadData(this.participant.potentialOwnerList);
      }
    }
  }

  private addPositionPerformer(positions: PositionParticipant[]) {
    for (const position of positions) {
      if (!position.performerId) {
        this.message.info(this.localePipe.transform('component.participant.selectPosition'));
        this.isClose = false;
      } else {
        if ((!position.orgType || position.orgType == null) && (position.isRequired && position.positionType === '1')) {
          this.message.info(this.localePipe.transform('component.participant.selectOrgType'));
          this.isClose = false;
        } else if ((!position.orgId || position.orgId == null) && (position.isRequired && position.positionType === '1')) {
          this.message.info(this.localePipe.transform('component.participant.orgFill'));
          this.isClose = false;
        } else {
          // (1)id一致，为编辑岗位；（2）performid一致，新增的用户，岗位已存在
          if (this.type === 'humanPerformer') {
            const i = this.participant.humanPerformerList.findIndex(a => {
              if (a.type !== 'wf.PositionParticipantExpression') {
                return false;
              }
              const p = a as PositionParticipant;
              return (p.id === position.id);
            });
            if (i > -1) {
              this.participant.humanPerformerList[i] = position;
            } else {
              let index;
              if (this.participant.humanPerformerList.length > 0) {
                index = Math.max(...this.participant.humanPerformerList.map(h => h.order))+1;
              } else {
                index = 1;
              }
              position.order = index;
              this.participant.humanPerformerList.push(position);
            }
            this.humanPerformerGrid.loadData(this.participant.humanPerformerList);
          } else if (this.type === 'potentialOwner') {
            const i = this.participant.potentialOwnerList.findIndex(a => {
              if (a.type !== 'wf.PositionParticipantExpression') {
                return false;
              }
              const p = a as PositionParticipant;
              return (p.id === position.id);
            });
            if (i > -1) {
              this.participant.potentialOwnerList[i] = position;
            } else {
              let index;
              if (this.participant.potentialOwnerList.length > 0) {
                index = Math.max(...this.participant.potentialOwnerList.map(p => p.order))+1;
              } else {
                index = 1;
              }
              position.order = index;
              this.participant.potentialOwnerList.push(position);
            }
            this.potentialOwnerGrid.loadData(this.participant.potentialOwnerList);
          }
        }
      }
    }
  }

  private addComponentPerformer(component: ComponentPerformer) {
    const cmp = new ComponentParticipant();
    cmp.id = component.id;
    cmp.metadataId = component.metadataId;
    cmp.methodCode = component.methodCode;
    cmp.methodName = component.methodName;
    cmp.name = component.name;
    cmp.actualParameters = component.actualParameters;
    cmp.type = 'wf.ComponentParticipantExpression';
    cmp.condition = component.condition;
    if (this.type === 'humanPerformer') {
      const i = this.participant.humanPerformerList.findIndex(a => a.id === cmp.id);
      if (i > -1) {
        cmp.order = i + 1;
        this.participant.humanPerformerList[i] = cmp;
      } else {
        let index;
        if (this.participant.humanPerformerList.length > 0) {
          index = Math.max(...this.participant.humanPerformerList.map(h => h.order))+1;
        } else {
          index = 1;
        }
        cmp.order = index;
        this.participant.humanPerformerList.push(cmp);
      }
      this.humanPerformerGrid.loadData(this.participant.humanPerformerList);
    } else if (this.type === 'potentialOwner') {
      const i = this.participant.potentialOwnerList.findIndex(a => a.id === cmp.id);
      if (i > -1) {
        cmp.order = i + 1;
        this.participant.potentialOwnerList[i] = cmp;
      } else {
        let index;
        if (this.participant.potentialOwnerList.length > 0) {
          index = Math.max(...this.participant.potentialOwnerList.map(p => p.order))+1;
        } else {
          index = 1;
        }
        cmp.order = index;
        this.participant.potentialOwnerList.push(cmp);
      }
      this.potentialOwnerGrid.loadData(this.participant.potentialOwnerList);
    }
  }

  private addReportingLinePerformer(reportingLine: ReportingLineParticipant) {
    if (reportingLine.reportingReferObject === 'dept' && !reportingLine.refOrgId) {
      this.isClose = false;
      this.message.info(this.localePipe.transform('component.participant.refOrgIdNotNull'));
    } else if (reportingLine.reportingReferObject !== 'dept' && !reportingLine.refUserId && !reportingLine.refEmployeeId) { // 用户及其他人员汇报对象类型，参照用户和参照员工不能全部为空
      this.isClose = false;
      this.message.info(this.localePipe.transform('component.participant.refUserIdNotNull'));
    } else {
      this.isClose = true;
      if (this.type === 'humanPerformer') {
        const i = this.participant.humanPerformerList.findIndex(a => a.id === reportingLine.id);
        if (i > -1) {
          this.participant.humanPerformerList[i] = reportingLine;
        } else {
          const reportingLines = this.participant.humanPerformerList.filter(h => h.type === 'wf.ReportingLineParticipantExpression');
          for (const r of reportingLines) {
            const reportingLineData = r as ReportingLineParticipant;
            if (reportingLineData.reportingLineDefId === reportingLine.reportingLineDefId &&
              reportingLineData.dimension === reportingLine.dimension &&
              reportingLineData.refUserId === reportingLine.refUserId &&
              reportingLineData.refEmployeeId === reportingLine.refEmployeeId &&
              reportingLineData.refOrgId === reportingLine.refOrgId
            ) {
              this.message.error(this.localePipe.transform('component.participant.repDefConfigured'));
              return;
            }
          }
          let index;
          if (this.participant.humanPerformerList.length > 0) {
            index = Math.max(...this.participant.humanPerformerList.map(h => h.order))+1;
          } else {
            index = 1;
          }
          reportingLine.order = index;
          this.participant.humanPerformerList.push(reportingLine);
        }
        this.humanPerformerGrid.loadData(this.participant.humanPerformerList);
      } else if (this.type === 'potentialOwner') {
        const i = this.participant.potentialOwnerList.findIndex(a => a.id === reportingLine.id);
        if (i > -1) {
          this.participant.potentialOwnerList[i] = reportingLine;
        } else {
          const reportingLines = this.participant.potentialOwnerList.filter(h => h.type === 'wf.ReportingLineParticipantExpression');
          for (const r of reportingLines) {
            const reportingLineData = r as ReportingLineParticipant;
            if (reportingLineData.reportingLineDefId === reportingLine.reportingLineDefId &&
              reportingLineData.dimension === reportingLine.dimension &&
              reportingLineData.refUserId === reportingLine.refUserId &&
              reportingLineData.refEmployeeId === reportingLine.refEmployeeId &&
              reportingLineData.refOrgId === reportingLine.refOrgId
            ) {
              this.message.error(this.localePipe.transform('component.participant.repDefConfigured'));
              return;
            }
          }
          let index;
          if (this.participant.potentialOwnerList.length > 0) {
            index = Math.max(...this.participant.potentialOwnerList.map(p => p.order))+1;
          } else {
            index = 1;
          }
          reportingLine.order = index;
          this.participant.potentialOwnerList.push(reportingLine);
        }
        this.potentialOwnerGrid.loadData(this.participant.potentialOwnerList);
      }
    }
  }

  private addMatrixPerformer(matrix: MatrixParticipant) {
    if (!matrix.conditionField1 && !matrix.conditionField2 && !matrix.conditionField3) {
      this.isClose = false;
      this.message.info(this.localePipe.transform('component.participant.atLeastOneCondition'));
    } else if (!matrix.dataFieldAlias) {
      this.isClose = false;
      this.message.info(this.localePipe.transform('component.participant.dataFieldAliasNotNull'));
    } else {
      this.isClose = true;
      if (this.type === 'humanPerformer') {
        const i = this.participant.humanPerformerList.findIndex(a => a.id === matrix.id);
        if (i > -1) {
          this.participant.humanPerformerList[i] = matrix;
        } else {
          const matrixParticipants = this.participant.humanPerformerList.filter(h => h.type === 'wf.MatrixParticipantExpression');
          for (const m of matrixParticipants) {
            const matrixData = m as MatrixParticipant;
            if (matrixData.matrixDefId === matrix.matrixDefId &&
              matrixData.conditionField1 === matrix.conditionField1 &&
              matrixData.conditionField2 === matrix.conditionField2 &&
              matrixData.conditionField3 === matrix.conditionField3 &&
              matrixData.dataFieldAlias === matrix.dataFieldAlias
            ) {
              this.message.error(this.localePipe.transform('component.participant.matrixConfigured'));
              return;
            }
          }
          let index;
          if (this.participant.humanPerformerList.length > 0) {
            index = Math.max(...this.participant.humanPerformerList.map(h => h.order))+1;
          } else {
            index = 1;
          }
          matrix.order = index;
          this.participant.humanPerformerList.push(matrix);
        }
        this.humanPerformerGrid.loadData(this.participant.humanPerformerList);
      } else if (this.type === 'potentialOwner') {
        const i = this.participant.potentialOwnerList.findIndex(a => a.id === matrix.id);
        if (i > -1) {
          this.participant.potentialOwnerList[i] = matrix;
        } else {
          const matrixParticipants = this.participant.potentialOwnerList.filter(h => h.type === 'wf.MatrixParticipantExpression');
          for (const m of matrixParticipants) {
            const matrixData = m as MatrixParticipant;
            if (matrixData.matrixDefId === matrix.matrixDefId &&
              matrixData.conditionField1 === matrix.conditionField1 &&
              matrixData.conditionField2 === matrix.conditionField2 &&
              matrixData.conditionField3 === matrix.conditionField3 &&
              matrixData.dataFieldAlias === matrix.dataFieldAlias
            ) {
              this.message.error(this.localePipe.transform('component.participant.matrixConfigured'));
              return;
            }
          }
          let index;
          if (this.participant.potentialOwnerList.length > 0) {
            index = Math.max(...this.participant.potentialOwnerList.map(p => p.order))+1;
          } else {
            index = 1;
          }
          matrix.order = index;
          this.participant.potentialOwnerList.push(matrix);
        }
        this.potentialOwnerGrid.loadData(this.participant.potentialOwnerList);
      }
    }
  }

  private addActivityExecutorPerformer(activityExecutor: ActivityExecutorParticipant) {
    if (this.type === 'humanPerformer') {
      const i = this.participant.humanPerformerList.findIndex(a => (a.id === activityExecutor.id ||
        ((a as ActivityExecutorParticipant).activityDefId && (a as ActivityExecutorParticipant).activityDefId === activityExecutor.activityDefId)));
      if (i < 0) {
        if (this.editState === 'edit') {
          this.removeHumanPerformer(); // 在编辑状态下配置了活动办理人参与者，先将选中的删除
        }
        let index;
        if (this.participant.humanPerformerList.length > 0) {
          index = Math.max(...this.participant.humanPerformerList.map(h => h.order))+1;
        } else {
          index = 1;
        }
        activityExecutor.order = index;
        this.participant.humanPerformerList.push(activityExecutor);
      }
      this.humanPerformerGrid.loadData(this.participant.humanPerformerList);
    } else if (this.type === 'potentialOwner') {
      const i = this.participant.potentialOwnerList.findIndex(a => (a.id === activityExecutor.id ||
        ((a as ActivityExecutorParticipant).activityDefId && (a as ActivityExecutorParticipant).activityDefId === activityExecutor.activityDefId)));
      if (i < 0) {
        if (this.editState === 'edit') {
          this.removePotentialOwner(); // 在编辑状态下配置了活动办理人参与者，先将选中的删除
        }
        let index;
        if (this.participant.potentialOwnerList.length > 0) {
          index = Math.max(...this.participant.potentialOwnerList.map(p => p.order))+1;
        } else {
          index = 1;
        }
        activityExecutor.order = index;
        this.participant.potentialOwnerList.push(activityExecutor);
      }
      this.potentialOwnerGrid.loadData(this.participant.potentialOwnerList);
    }
  }


  private addOrganizationParticipant(organization: OrganizationParticipantExpression) {
    const organizationParticipant = new OrganizationParticipant();
    organizationParticipant.id = organization.id || ProcessDeUtil.GenerateElementId();
    organizationParticipant.type = 'wf.OrganizationParticipantExpression';
    organizationParticipant.condition = organization.condition;
    organizationParticipant.name = organization.name;
    organizationParticipant.actionScope = organization.actionScope;
    organizationParticipant.organizationLevel = organization.organizationLevel;
    organizationParticipant.organizationId = organization.organizationId;
    organizationParticipant.organizationCode = organization.organizationCode;
    organizationParticipant.organizationName = organization.organizationName;
    organizationParticipant.includeChildren = organization.includeChildren;
    organizationParticipant.parentsUntil = organization.parentsUntil;
    organizationParticipant.tag = organization.tag;

    if (this.type === 'humanPerformer') {
      this.participant.humanPerformerList = this.participant.humanPerformerList.filter(p => p.type !== 'wf.OrganizationParticipantExpression');
      let index;
      if (this.participant.humanPerformerList.length > 0) {
        index = Math.max(...this.participant.humanPerformerList.map(h => h.order))+1;
      } else {
        index = 1;
      }
      organizationParticipant.order = index;
      this.participant.humanPerformerList.push(organizationParticipant);
      this.humanPerformerGrid.loadData(this.participant.humanPerformerList);
    } else if (this.type === 'potentialOwner') {
      this.participant.potentialOwnerList = this.participant.potentialOwnerList.filter(p => p.type !== 'wf.OrganizationParticipantExpression');
      let index;
      if (this.participant.potentialOwnerList.length > 0) {
        index = Math.max(...this.participant.potentialOwnerList.map(p => p.order))+1;
      } else {
        index = 1;
      }
      organizationParticipant.order = index;
      this.participant.potentialOwnerList.push(organizationParticipant);
      this.potentialOwnerGrid.loadData(this.participant.potentialOwnerList);
    }
  }

  editCancel() {
    if (this.editDialog) {
      this.editDialog.close();
    }
  }

  editPerformer(type: string) {
    this.editState = 'edit';
    this.type = type;
    let selectedRow;
    if (type === 'humanPerformer') {
      selectedRow = this.humanPerformerGrid.selectedRow;
    } else if (type === 'potentialOwner') {
      selectedRow = this.potentialOwnerGrid.selectedRow;
    }
    if (!selectedRow) {
      this.message.info(this.localePipe.transform('component.participant.selectPerformer'));
      return;
    }
    const curPerformer = selectedRow.data;
    if (curPerformer) {
      const boxsize = this.attributeBoxSize(curPerformer.type);
      const modalConfig = {
        title: this.localePipe.transform('component.participant.participantSelection'),
        width: boxsize.width,
        height: boxsize.height,
        buttons: this.editFooter,
        showButtons: true
      };
      const compFactory = this.resolver.resolveComponentFactory(PerformerEditComponent);
      this.compRef = compFactory.create(this.injector);
      this.compRef.instance.performerType = curPerformer.type;
      this.compRef.instance.editState =  this.editState;
      switch (curPerformer.type) {
        case 'wf.PositionParticipantExpression':
          this.compRef.instance.performer = {
            type: 'wf.PositionParticipantExpression',
            value: curPerformer
          };
          break;
        case 'wf.UserParticipantExpression':
          this.compRef.instance.performer = {
            type: 'wf.UserParticipantExpression',
            value: curPerformer
          };
          break;
        case 'wf.VariableParticipantExpression':
          this.compRef.instance.performer = {
            type: 'wf.VariableParticipantExpression',
            value: curPerformer
          };
          break;
        case 'wf.ReportingLineParticipantExpression':
          this.compRef.instance.performer = {
            type: 'wf.ReportingLineParticipantExpression',
            value: curPerformer
          };
          const url = '/api/runtime/wf/v1.0/reportingLineDefinitions/' + (curPerformer as ReportingLineParticipant).reportingLineDefId;
          this.http.get(url).subscribe((res: any) => {
            if (!res) {
              this.message.error(this.localePipe.transform('component.participant.definitionDeleted'));
              if (type === 'humanPerformer') {
                this.removeHumanPerformer();
              } else if (type === 'potentialOwner') {
                this.removePotentialOwner();
              }
            } else {
              this.editDialog = this.modalService.show(this.compRef, modalConfig);
            }
          });
          break;
        case 'wf.MatrixParticipantExpression':
          this.compRef.instance.performer = {
            type: 'wf.MatrixParticipantExpression',
            value: curPerformer
          };
          const urlMatrix = '/api/runtime/wf/v1.0/matrixDefinition/' + (curPerformer as MatrixParticipant).matrixDefId;
          this.http.get(urlMatrix).subscribe((res: any) => {
            if (!res) {
              this.message.error(this.localePipe.transform('component.participant.matrixDeleted'));
              if (type === 'humanPerformer') {
                this.removeHumanPerformer();
              } else if (type === 'potentialOwner') {
                this.removePotentialOwner();
              }
            } else {
              this.editDialog = this.modalService.show(this.compRef, modalConfig);
            }
          });
          break;
        case 'wf.ComponentParticipantExpression':
          this.compRef.instance.performer = {
            type: 'wf.ComponentParticipantExpression',
            value: curPerformer
          };
          break;
        case 'wf.ActivityExecutorParticipantExpression':
          this.compRef.instance.performer = {
            type: 'wf.ActivityExecutorParticipantExpression',
            value: curPerformer
          };
          break;
        case 'wf.OrganizationParticipantExpression':
          this.compRef.instance.performer = {
            type: 'wf.OrganizationParticipantExpression',
            value: curPerformer
          };
          break;
      }
      if (curPerformer.type !== 'wf.ReportingLineParticipantExpression' &&
        curPerformer.type !== 'wf.MatrixParticipantExpression') { // 汇报关系和矩阵单独处理
        this.editDialog = this.modalService.show(this.compRef, modalConfig);
      }
    }
  }
  removePerformer(type: string) {
    if (type === 'humanPerformer') {
      if (this.humanPerformerGrid.selectedRow) {
        this.humanPerformerGrid.endCellEdit();
        const index = this.participant.humanPerformerList.findIndex(p => p.id === this.humanPerformerGrid.selectedRow.data.id);
        this.participant.humanPerformerList.splice(index, 1);
        this.humanPerformerGrid.loadData(this.participant.humanPerformerList);
      } else {
        this.message.info(this.localePipe.transform('component.participant.selectParticipantInfo'));
      }
    } else if (type === 'potentialOwner') {
      if (this.potentialOwnerGrid.selectedRow) {
        this.potentialOwnerGrid.endCellEdit();
        const index = this.participant.potentialOwnerList.findIndex(p => p.id === this.potentialOwnerGrid.selectedRow.data.id);
        this.participant.potentialOwnerList.splice(index, 1);
        this.potentialOwnerGrid.loadData(this.participant.potentialOwnerList);
      } else {
        this.message.info(this.localePipe.transform('component.participant.selectParticipantInfo'));
      }
    }
  }

  clearPerformer(type: string) {
    if (type === 'humanPerformer') {
      this.participant.humanPerformerList = new Array();
    } else if (type === 'potentialOwner') {
      this.participant.potentialOwnerList = new Array();
    }
    this.humanPerformerGrid.loadData(this.participant.humanPerformerList);
    if (this.potentialOwnerGrid) {
      this.potentialOwnerGrid.loadData(this.participant.potentialOwnerList);
    }
  }

  moveUp(type: string) {
    if (type === 'humanPerformer') {
      const selectedRow = this.humanPerformerGrid.selectedRow;
      if (!selectedRow) {
        this.message.info(this.localePipe.transform('component.participant.noRowSelected'));
        return;
      }
      const performer = selectedRow.data;
      const i = this.participant.humanPerformerList.findIndex(c => c.id === performer.id);
      if (i === 0) {
        return;
      }
      const index = this.participant.humanPerformerList[i].order;
      this.participant.humanPerformerList[i].order = this.participant.humanPerformerList[i - 1].order;
      this.participant.humanPerformerList[i-1].order = index;
      this.swapArray(this.participant.humanPerformerList, i, i - 1);
      this.humanPerformerGrid.loadData(this.participant.humanPerformerList);
      this.humanPerformerGrid.selectRow(performer.id, true);
    } else if (type === 'potentialOwner') {
      const selectedRow = this.potentialOwnerGrid.selectedRow;
      if (!selectedRow) {
        this.message.info(this.localePipe.transform('component.participant.noRowSelected'));
        return;
      }
      const performer = selectedRow.data;
      const i = this.participant.potentialOwnerList.findIndex(c => c.id === performer.id);
      if (i === 0) {
        return;
      }
      const index = this.participant.potentialOwnerList[i].order;
      this.participant.potentialOwnerList[i].order = this.participant.potentialOwnerList[i - 1].order;
      this.participant.potentialOwnerList[i-1].order = index;
      this.swapArray(this.participant.potentialOwnerList, i, i - 1);
      this.potentialOwnerGrid.loadData(this.participant.potentialOwnerList);
      this.potentialOwnerGrid.selectRow(performer.id, true);
    }

  }

  moveDown(type: string) {
    if (type === 'humanPerformer') {
      const selectedRow = this.humanPerformerGrid.selectedRow;
      if (!selectedRow) {
        this.message.info(this.localePipe.transform('component.participant.noRowSelected'));
        return;
      }
      const performer = selectedRow.data;
      const i = this.participant.humanPerformerList.findIndex(c => c.id === performer.id);
      if (i === this.participant.humanPerformerList.length-1) {
        return;
      }
      const index = this.participant.humanPerformerList[i].order;
      this.participant.humanPerformerList[i].order = this.participant.humanPerformerList[i + 1].order;
      this.participant.humanPerformerList[i+1].order = index;
      this.swapArray(this.participant.humanPerformerList, i, i + 1);
      this.humanPerformerGrid.loadData(this.participant.humanPerformerList);
      this.humanPerformerGrid.selectRow(performer.id, true);
    } else if (type === 'potentialOwner') {
      const selectedRow = this.potentialOwnerGrid.selectedRow;
      if (!selectedRow) {
        this.message.info(this.localePipe.transform('component.participant.noRowSelected'));
        return;
      }
      const performer = selectedRow.data;
      const i = this.participant.potentialOwnerList.findIndex(c => c.id === performer.id);
      if (i === this.participant.potentialOwnerList.length-1) {
        return;
      }
      const index = this.participant.potentialOwnerList[i].order;
      this.participant.potentialOwnerList[i].order = this.participant.potentialOwnerList[i + 1].order;
      this.participant.potentialOwnerList[i+1].order = index;
      this.swapArray(this.participant.potentialOwnerList, i, i + 1);
      this.potentialOwnerGrid.loadData(this.participant.potentialOwnerList);
      this.potentialOwnerGrid.selectRow(performer.id, true);
    }
  }

  private swapArray(arr: Array<any>, i1: number, i2: number): Array<any> {
    arr[i1] = arr.splice(i2, 1, arr[i1])[0];
    return arr;
  }

  removeHumanPerformer() {
    if (this.humanPerformerGrid.selectedRow) {
      this.humanPerformerGrid.endCellEdit();
      const i = this.participant.humanPerformerList.findIndex(item => item.id === this.humanPerformerGrid.selectedRow.data.id);
      this.participant.humanPerformerList.splice(i, 1);
    } else {
      this.message.info(this.localePipe.transform('component.participant.selectDefaultHandler'));
    }
  }

  removePotentialOwner() {
    if (this.potentialOwnerGrid.selectedRow) {
      this.potentialOwnerGrid.endCellEdit();
      const i = this.participant.potentialOwnerList.findIndex(item => item.id === this.potentialOwnerGrid.selectedRow.data.id);
      this.participant.potentialOwnerList.splice(i, 1);
    } else {
      this.message.info(this.localePipe.transform('component.participant.selectpotentialtHandler'));
    }
  }

  private getUserPerformerDescription(userPerformer: UserParticipant): string {
    if (userPerformer.tag === 'expression') {
      return userPerformer.performerId;
    } else {
      if (userPerformer.orgName) {
        if(userPerformer.performerCode) {
          return this.localePipe.transform('component.participant.code') + userPerformer.performerCode + '，' + this.localePipe.transform('component.participant.org') + userPerformer.orgName;
        }else {
          return this.localePipe.transform('component.participant.org') + userPerformer.orgName;
        }
      } else {
        return '';
      }
    }
  }

  private getVariablePerformerDescription(variablePerformer: VariableParticipant): string {
    if (variablePerformer.tag === 'expression') {
      return variablePerformer.varValue;
    }
  }

  private getPositionPerformerDescription(position: PositionParticipant): string {
    if (this.designerUIState.scene === 'inSuite') {
      return null;
    }
    if (position.positionType === '1') {
      if (position.orgId) {
        if(position.performerCode) {
          return this.localePipe.transform('component.participant.code') + position.performerCode + '，' + this.localePipe.transform('component.participant.positionType1') + position.orgId;
        }else {
          return this.localePipe.transform('component.participant.positionType1') + position.orgId;
        }
      } else {
        if(position.performerCode) {
          return this.localePipe.transform('component.participant.code') + position.performerCode + '，' + this.localePipe.transform('component.participant.positionType2');
        }else {
          return this.localePipe.transform('component.participant.positionType2');
        }
      }
    } else if (position.positionType === '0') {
      if(position.performerCode) {
        return this.localePipe.transform('component.participant.code') + position.performerCode + '，' + this.localePipe.transform('component.participant.positionType3');
      }else {
        return this.localePipe.transform('component.participant.positionType3');
      }
    }
  }

  private getComponentPerformerDescription(position: ComponentParticipant): string {
    let des = this.localePipe.transform('component.participant.comp') + position.name
    + this.localePipe.transform('component.participant.parameters');
    if (position.actualParameters && position.actualParameters.length > 0) {
      position.actualParameters.forEach(p => {
        des += `${p.code}：${p.value}，`;
      });
      des = des.substring(0, des.length - 1);
    }
    des += '}';
    return des;
  }

  private getReportingLinePerformerDescription(reportingLine: ReportingLineParticipant): string {
    let description = '';
    if (reportingLine.refUserId) {
      description += this.localePipe.transform('component.participant.referencePerson') + reportingLine.refUserId;
    }
    if (reportingLine.refEmployeeId) {
      description += this.localePipe.transform('component.participant.referencePerson') + reportingLine.refEmployeeId;
    }
    if (reportingLine.refOrgId) {
      if (reportingLine.refUserId) {
        description += `，`;
      }
      if (reportingLine.refEmployeeId) {
        description += `，`;
      }
      description += this.localePipe.transform('component.participant.referenceOrganization') + reportingLine.refOrgId;
    }
    return description;
  }

  private getMatrixPerformerDescription(matrix: MatrixParticipant): string {
    let description = '';
    if (matrix.conditionField1) {
      description += this.localePipe.transform('component.participant.condition1') + matrix.conditionFieldText1 + `，`;
    }
    if (matrix.conditionField2) {
      description += this.localePipe.transform('component.participant.condition2') + matrix.conditionFieldText2 + `，`;
    }
    if (matrix.conditionField3) {
      description += this.localePipe.transform('component.participant.condition3') + matrix.conditionFieldText3 + `，`;
    }
    if (matrix.dataFieldAlias) {
      description += this.localePipe.transform('component.participant.data') + matrix.dataFieldAlias + `，`;
    }
    return description.slice(0, description.length - 1);
  }

  private editConditon(e: any) {
    // this.expr.clearContext();
    
    if (this.designerUIState.schemas.length > 0) {
      for (const schema of this.designerUIState.schemas) {
        this.expr.addSchema('Schema', schema);
      }
      if (this.designerUIState.schemas[0].entityTypes && this.designerUIState.schemas[0].entityTypes.length > 0) {
        const entityType = this.designerUIState.schemas[0].entityTypes[0];
        this.expr.addInjectedEntity(entityType.name, 'Schema',
          entityType.name, InjectedType.EntityType);
      }
    }
    let context = new Array();
    context = this.designerUIState.addContext(context);
    if (this.designerUIState.subActivityContext.length > 0) {
      for (const variable of this.designerUIState.subActivityContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (this.designerUIState.activityComponentContext.length > 0) {
      for (const variable of this.designerUIState.activityComponentContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (context.length > 0) {
      for (const v of context) {
        this.expr.addContext(v);
      }
    }
    this.expr.addExpressionText(e.instance.value);
    this.expr.setEditPattern(ExprEditMode.Conditional); // 默认打开简易表达式编辑器
    this.expr.buildExpression().then((cond: string) => {
      if(this.humanPerformerGrid && this.humanPerformerGrid.selectedRow && this.humanPerformerGrid.selectedRow.data) {
        let temp = this.participant.humanPerformerList.find(h => h.id === this.humanPerformerGrid.selectedRow.data.id);
        temp.condition = cond;
      }
      if(this.potentialOwnerGrid && this.potentialOwnerGrid.selectedRow && this.potentialOwnerGrid.selectedRow.data) {
        let temp = this.participant.potentialOwnerList.find(h => h.id === this.potentialOwnerGrid.selectedRow.data.id);
        temp.condition = cond;
      }

      e.formControl.setValue(cond);
      e.instance.cd.detectChanges();
      //点击确定后，去除表达式里面的新增的上下文变量
      if(context.length > 0) {
        this.expr.exprEntity.contextEntities = this.expr.exprEntity.contextEntities.filter(x => !context.some(y => y.key === x.key));
      }
    });
  }

  private humanPerformerCopyToPotentialOwner() {
    if (this.participant.humanPerformerList && this.participant.humanPerformerList.length > 0) {
      if (!this.participant.potentialOwnerList) {
        this.participant.potentialOwnerList = new Array();
      }
      this.participant.potentialOwnerList.push(...this.participant.humanPerformerList);
      this.participant.humanPerformerList = new Array();

      this.humanPerformerGrid.loadData(this.participant.humanPerformerList);
      if (this.potentialOwnerGrid) {
        this.potentialOwnerGrid.loadData(this.participant.potentialOwnerList);
      }
    }
  }

  private potentialOwnerCopyToHumanPerformer() {
    if (this.participant.potentialOwnerList && this.participant.potentialOwnerList.length > 0) {
      if (!this.participant.humanPerformerList) {
        this.participant.humanPerformerList = new Array();
      }
      const performers = this.participant.potentialOwnerList.filter(p => p.type !== 'wf.OrganizationParticipantExpression');
      if (performers && performers.length > 0) {
        // 此处直接push会导致order重复,需要重新排序
        this.participant.humanPerformerList.push(...performers);
        this.participant.humanPerformerList.forEach((human, index) => {
          human.order = index + 1;
        });
        this.participant.potentialOwnerList = this.participant.potentialOwnerList.filter(p => p.type === 'wf.OrganizationParticipantExpression');
        this.humanPerformerGrid.loadData(this.participant.humanPerformerList);
        if (this.potentialOwnerGrid) {
          this.potentialOwnerGrid.loadData(this.participant.potentialOwnerList);
        }
      }
    }
  }

  private GetOrganizationType() {
    const url = '/api/runtime/sys/v1.0/authfields/globalauthfields';
    this.http.get(url)
      .subscribe((data: any) => this.designerUIState.orgTypeCollection = data.map(d => ({ value: d.id, text: d.name })));
  }

  // 构造不同参与者选择界面的尺寸 2023-7-5
  private attributeBoxSize(boxType: string) {
    const boxsize = {
      width: 760,
      height: 512
    }
    switch (boxType) {
      case 'wf.PositionParticipantExpression':
        boxsize.width = 760;
        boxsize.height = 455;
        return boxsize;
      case 'wf.UserParticipantExpression':
        boxsize.width = 760;
        boxsize.height = 320;
        return boxsize;
      case 'wf.VariableParticipantExpression':
        boxsize.width = 760;
        boxsize.height = 420;
        return boxsize;;
      case 'wf.ReportingLineParticipantExpression':
        boxsize.width = 760;
        boxsize.height = 512;
        return boxsize;;
      case 'wf.MatrixParticipantExpression':
        boxsize.width = 780;
        boxsize.height = 420;
        return boxsize;;
      case 'wf.ComponentParticipantExpression':
        boxsize.width = 760;
        boxsize.height = 512;
        return boxsize;;
      case 'wf.ActivityExecutorParticipantExpression':
        boxsize.width = 760;
        boxsize.height = 320;
        return boxsize;;
      case 'wf.OrganizationParticipantExpression':
        boxsize.width = 760;
        boxsize.height = 360;
        return boxsize;;
    }
  }
}

export class ParticipantConverter implements TypeConverter {
  constructor(
    private localePipe: WfLocalePipe
  ) { }

  convertTo(data: ParticipantInfo): string {
    if (data && data.humanPerformerList && data.humanPerformerList.length > 0) {
      return this.localePipe.transform("component.participant.set");
    }
    if (data && data.potentialOwnerList && data.potentialOwnerList.length > 0) {
      return this.localePipe.transform("component.participant.set");
    }
    if (data && data.isAllScope) {
      return this.localePipe.transform("component.participant.set");
    }
    return this.localePipe.transform("component.participant.notSet");
  }
}
